module.exports = __webpack_public_path__ + "img/section1_tab4_img.ba138b62.svg";